import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { UserIcon, CodeIcon, HeartHandshakeIcon } from 'lucide-react';
import { Badge } from '../../Badge';
export function FounderStory() {
  const reduce = useReducedMotion();
  return <section id="founder" className="w-full bg-white" data-id="element-76" data-mp="924jdnq5nbne">
      <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-24" data-id="element-77" data-mp="dyl6celmbjyw">
        <div className="grid items-center gap-12 lg:grid-cols-2" data-id="element-78" data-mp="11oz0canrjsw4">
          {/* Portrait / identity block */}
          <motion.div initial={reduce ? undefined : {
          opacity: 0,
          y: 20
        }} whileInView={reduce ? undefined : {
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="order-2 lg:order-1" data-id="element-79" data-mp="16ns255totvgg">
            <div className="relative mx-auto max-w-sm" data-id="element-80" data-mp="1le2s659ueab9">
              <div className="aspect-square w-full rounded-2xl border border-border bg-surface-muted" data-id="element-81" data-mp="1gegexvu0ku2g">
                <div className="flex h-full w-full flex-col items-center justify-center gap-4 p-8 text-center" data-id="element-82" data-mp="1uehixk5kshm5">
                  <span className="inline-flex h-20 w-20 items-center justify-center rounded-full bg-deep-navy text-white" data-id="element-83" data-mp="1pcie05u6tcn3">
                    <UserIcon className="h-9 w-9" aria-hidden="true" data-id="element-84" data-mp="1zc0w0gqjeoci" />
                  </span>
                  <div data-id="element-85" data-mp="1za6i3mdonwhx">
                    <p className="font-heading text-lg font-bold text-text" data-id="element-86" data-mp="2d3xia45iy40z">
                      代表 / ソロプレナー
                    </p>
                    <p className="mt-1 text-sm text-text-muted" data-id="element-87" data-mp="292cbn0jl2lz8">
                      OptiDSA 創業者
                    </p>
                  </div>
                  <div className="flex flex-wrap justify-center gap-2" data-id="element-88" data-mp="2i2inyj3jpfwt">
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1 text-xs font-medium text-deep-navy ring-1 ring-border" data-id="element-89" data-mp="2i0e7l1ogmofn">
                      <CodeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-90" data-mp="1jrpqu3b63wo4" />
                      開発経験10年以上
                    </span>
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1 text-xs font-medium text-deep-navy ring-1 ring-border" data-id="element-91" data-mp="1oog6ipj28q90">
                      <HeartHandshakeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-92" data-mp="1ygdhpwa2ji7q" />
                      伴走型
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Story copy */}
          <motion.div initial={reduce ? undefined : {
          opacity: 0,
          y: 20
        }} whileInView={reduce ? undefined : {
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="order-1 lg:order-2" data-id="element-93" data-mp="2cek6mmx1i7v9">
            <Badge variant="sage" style={{
            color: '#5E8F7A',
            backgroundColor: 'rgba(94, 143, 122, 0.15)',
            borderColor: 'rgba(94, 143, 122, 0.3)'
          }} className="border" data-id="element-94" data-mp="3rwghqxgxonyx">
              創業者の想い
            </Badge>
            <h2 className="mt-4 font-heading text-2xl font-bold text-text sm:text-3xl" data-id="element-95" data-mp="fh63kbdf3jn9">
              元エンジニアが、地元・横須賀で立ち上げました。
            </h2>
            <div className="mt-5 space-y-4 text-base leading-relaxed text-text" data-id="element-96" data-mp="34aa1xp19q3y5">
              <p data-id="element-97" data-mp="30628jejv7ztl">
                私は、10年以上の経験を持つ元ソフトウェアエンジニアです。長年、現場で「便利なはずのITが、逆に人を振り回している」場面を数多く見てきました。
              </p>
              <p data-id="element-98" data-mp="rx47t11xuplt">
                OptiDSA
                は、その課題を地元・横須賀の中小企業のために解決したいという想いから立ち上げた、ひとり体制の伴走型エージェンシーです。
                <strong className="text-deep-navy" data-id="element-99" data-mp="wqyodvm8yogo">
                  正直にお伝えすると、まだ実績のない、始まったばかりの会社です。
                </strong>
                だからこそ、大手のように件数をこなすのではなく、お引き受けする一社一社に本気で向き合えます。
              </p>
              <p data-id="element-100" data-mp="mwzshecro0x6">
                難しい専門用語は使いません。あなたの現場の困りごとに親身に寄り添い、時には厳しく本質的な提案もしながら、無駄を省いた最適なやり方を一緒に見つけていきます。
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}